var BREAK_POINT_OPTIONS = [{
  value: 'mobile',
  label: '모바일'
}, {
  value: 'tablet',
  label: '태블릿'
}, {
  value: 'laptop',
  label: '랩탑'
}, {
  value: 'desktop',
  label: '데스크탑'
}];
var INITIAL_GRID_DATA = {
  column: 2,
  columnRatio: [1, 1],
  gap: 10,
  verticalAlign: 'flex-start'
};

export { BREAK_POINT_OPTIONS, INITIAL_GRID_DATA };
//# sourceMappingURL=types.js.map
